<template>
  <div class="page-wrap">
    <div class="profile">
      <div class="profile-main cards__single">
        <div class="profile-main__header">
          <div class="flex mb-2">
            <div class="profile-main__avatar cp" v-if="company.logo_path">
              <img class="cp" :src="$media_url + company.logo_path" alt=""
                   @click="index=0"/>
            </div>
            <div v-else class="mb-3"></div>
            <v-file-input class="file-input--hide" v-model="photo" accept=".jpg, .png, .jpeg"
                          :placeholder="$vuetify.lang.t('$vuetify.downloadPhoto')" id="photo"></v-file-input>
            <div v-if="editing" class="link" @click="clickInput">
              <span v-if="photo">{{ photo.name }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.changePhoto') }}</span>
            </div>
          </div>
          <div class="profile-main__name h2 profile-main__name--settings" v-if="!editing">
            <span>{{ company.name }} -
            </span>

            <router-link :to="'/partners/'+company.id">{{ $vuetify.lang.t('$vuetify.myPage') }}</router-link>

          </div>
          <div class="profile-main__post" v-if="editing">
            <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="company.name" outlined
                          :rules="[$rules.required]"></v-text-field>
          </div>

          <button class="editing-btn" @click="editing = !editing">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.8934 3.38037C16.5059 2.769 17.3317 2.41924 18.1969 2.40476C19.0622 2.39029 19.8993 2.71224 20.5318 3.30278C21.1644 3.89333 21.543 4.70635 21.5879 5.57054C21.6328 6.43474 21.3405 7.28263 20.7726 7.93557L20.6166 8.10357L9.08941 19.6308C8.8437 19.8761 8.5477 20.0653 8.22181 20.1852L8.02381 20.2488L3.15781 21.576C3.06355 21.6019 2.96438 21.6045 2.86891 21.5834C2.77345 21.5623 2.68458 21.5182 2.61006 21.4549C2.53553 21.3916 2.4776 21.311 2.44131 21.2203C2.40502 21.1295 2.39146 21.0312 2.40181 20.934L2.42101 20.838L3.74821 15.9732C3.83941 15.6372 4.00261 15.3252 4.22581 15.0612L4.36621 14.9076L15.8934 3.38037ZM14.8614 6.11037L5.21461 15.756C5.10439 15.8664 5.01676 15.9972 4.95661 16.1412L4.90621 16.2888L3.85381 20.1408L7.70821 19.0908C7.80861 19.0634 7.90502 19.023 7.99501 18.9708L8.12341 18.8844L8.24101 18.7824L17.8866 9.13437L14.8614 6.11037ZM19.7682 4.22877C19.3908 3.85113 18.8859 3.6282 18.3526 3.60378C17.8193 3.57936 17.2961 3.7552 16.8858 4.09677L16.7418 4.22877L15.7098 5.26077L18.7338 8.28717L19.7682 7.25517C20.1459 6.8778 20.3688 6.37289 20.3932 5.83957C20.4176 5.30626 20.2418 4.78308 19.9002 4.37277L19.7682 4.22877Z"
                fill="#ADB2B7"/>
            </svg>
          </button>
        </div>

        <div class="profile-main__options" v-if="!editing">
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.6 17.6005C5.41435 17.6005 5.2363 17.6743 5.10503 17.8056C4.97375 17.9368 4.9 18.1149 4.9 18.3005C4.9 18.4862 4.97375 18.6642 5.10503 18.7955C5.2363 18.9268 5.41435 19.0005 5.6 19.0005H8.4C8.58565 19.0005 8.7637 18.9268 8.89497 18.7955C9.02625 18.6642 9.1 18.4862 9.1 18.3005C9.1 18.1149 9.02625 17.9368 8.89497 17.8056C8.7637 17.6743 8.58565 17.6005 8.4 17.6005H5.6Z"
                  fill="#557EAE"/>
                <path
                  d="M2.8 0.800537C2.05739 0.800537 1.3452 1.09554 0.820101 1.62064C0.294999 2.14574 0 2.85793 0 3.60054V20.4005C0 21.1431 0.294999 21.8553 0.820101 22.3804C1.3452 22.9055 2.05739 23.2005 2.8 23.2005H11.2C11.9426 23.2005 12.6548 22.9055 13.1799 22.3804C13.705 21.8553 14 21.1431 14 20.4005V3.60054C14 2.85793 13.705 2.14574 13.1799 1.62064C12.6548 1.09554 11.9426 0.800537 11.2 0.800537H2.8ZM1.4 3.60054C1.4 3.22923 1.5475 2.87314 1.81005 2.61059C2.0726 2.34804 2.4287 2.20054 2.8 2.20054H11.2C11.5713 2.20054 11.9274 2.34804 12.1899 2.61059C12.4525 2.87314 12.6 3.22923 12.6 3.60054V20.4005C12.6 20.7718 12.4525 21.1279 12.1899 21.3905C11.9274 21.653 11.5713 21.8005 11.2 21.8005H2.8C2.4287 21.8005 2.0726 21.653 1.81005 21.3905C1.5475 21.1279 1.4 20.7718 1.4 20.4005V3.60054Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.phone') }}</div>

            <div class="profile-main__option-val" v-if="company.phone">
              <a :href="'tel:' + company.phone.replace(/\D/g, '')">{{ company.phone }} </a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.7008 0.599854C20.629 0.599854 21.5193 0.968602 22.1757 1.62498C22.832 2.28136 23.2008 3.1716 23.2008 4.09985V15.2999C23.2008 16.2281 22.832 17.1184 22.1757 17.7747C21.5193 18.4311 20.629 18.7999 19.7008 18.7999H4.30078C3.37252 18.7999 2.48228 18.4311 1.82591 17.7747C1.16953 17.1184 0.800781 16.2281 0.800781 15.2999V4.09985C0.800781 3.1716 1.16953 2.28136 1.82591 1.62498C2.48228 0.968602 3.37252 0.599854 4.30078 0.599854H19.7008ZM21.8008 6.14525L12.3564 11.7033C12.2671 11.7557 12.1673 11.7876 12.0642 11.7968C11.961 11.806 11.8571 11.7922 11.76 11.7565L11.6452 11.7033L2.20078 6.14805V15.2999C2.20078 15.8568 2.42203 16.391 2.81586 16.7848C3.20968 17.1786 3.74383 17.3999 4.30078 17.3999H19.7008C20.2577 17.3999 20.7919 17.1786 21.1857 16.7848C21.5795 16.391 21.8008 15.8568 21.8008 15.2999V6.14525ZM19.7008 1.99985H4.30078C3.74383 1.99985 3.20968 2.2211 2.81586 2.61493C2.42203 3.00876 2.20078 3.5429 2.20078 4.09985V4.52265L12.0008 10.2879L21.8008 4.51985V4.09985C21.8008 3.5429 21.5795 3.00876 21.1857 2.61493C20.7919 2.2211 20.2577 1.99985 19.7008 1.99985Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">email</div>

            <div class="profile-main__option-val">
              <a :href="'mailto:' + company.email">{{ company.email }}</a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM16.8 9C16.8 10.9778 15.7985 13.0015 14.4 14.4C13.0015 15.7985 10.9778 16.8 9 16.8C7.02224 16.8 4.99849 15.7985 3.6 14.4C2.20151 13.0015 1.2 10.9778 1.2 9C1.2 7.02224 2.20151 4.99849 3.6 3.6C4.99849 2.20151 7.02224 1.2 9 1.2C10.9778 1.2 13.0015 2.20151 14.4 3.6C15.7985 4.99849 16.8 7.02224 16.8 9Z"
                      fill="#2C1521"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M5.14286 9.00001C5.14286 13.6512 6.67646 17.4857 9 17.4857C11.3235 17.4857 12.8571 13.6512 12.8571 9.00001C12.8571 4.34881 11.3235 0.514291 9 0.514291C6.67646 0.514291 5.14286 4.34881 5.14286 9.00001ZM11.6603 9.00001C11.6603 12.8695 10.0851 16.29 9 16.29C7.91486 16.29 6.34028 12.8695 6.34028 9.00001C6.34028 5.13052 7.91486 1.71001 9 1.71001C10.0851 1.71001 11.6603 5.13052 11.6603 9.00001Z"
                      fill="#2C1521"/>
                <path
                  d="M2.41908 4.3375L3.45383 3.19373C3.55668 3.2863 3.6688 3.37887 3.78811 3.46835C5.09543 4.44755 7.1824 5.39 9.46068 5.39C11.4057 5.39 13.217 4.61315 14.5326 3.86127C14.8494 3.68024 15.1312 3.48378 15.375 3.27498L16.3768 4.44858C16.0579 4.72115 15.6969 4.97315 15.2989 5.19944C13.7395 6.09224 11.6639 6.59418 9.46068 6.59418C6.86663 6.59418 4.45669 5.89681 2.8624 4.70264C2.7091 4.5878 2.56117 4.46596 2.41908 4.3375Z"
                  fill="#2C1521"/>
                <path
                  d="M2.41908 13.679L3.45383 14.8227C3.55668 14.7291 3.6688 14.6376 3.78811 14.5481C5.09543 13.5689 7.1824 12.61 9.46068 12.61C11.4057 12.61 13.217 13.4033 14.5326 14.1552C14.8494 14.3362 15.1312 14.5327 15.375 14.7415L16.3768 13.5679C16.0417 13.2845 15.6808 13.0331 15.2989 12.817C13.7395 11.9242 11.6639 11.4223 9.46068 11.4223C6.86663 11.4223 4.45669 12.1196 2.8624 13.3138C2.7091 13.4287 2.56117 13.5505 2.41908 13.679Z"
                  fill="#2C1521"/>
                <path d="M1 9.6V8.4H17V9.6H1Z" fill="#2C1521"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.website') }}</div>

            <div class="profile-main__option-val">
              <a :href="'mailto:' + company.web">{{ company.web }}</a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.ogrn') }}

            </div>

            <div class="profile-main__option-val">
              {{ company.ogrn }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.vat') }}

            </div>

            <div class="profile-main__option-val">
              {{ company.van }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                  fill="#557EAE"/>
                <path
                  d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.address') }}</div>

            <div class="profile-main__option-val" v-if="company.address">
              <a target="_blank"
                 :href="'https://www.google.com/maps/search/?api=1&query='+company.address.street + '+' + company.address.house + '+' + company.address.city">
                {{ company.address.street }} {{ company.address.house }}{{
                  company.address.entrance ? company.address.entrance : ''
                }} {{
                  company.address.flat
                }}, {{ company.address.index }} {{
                  company.address.city
                }}, {{ company.address.country }}
              </a>
            </div>
          </div>
        </div>

        <div class="profile-main__options no-gap" v-if="editing">
          <v-text-field :label="$vuetify.lang.t('$vuetify.phone')" v-model="company.phone" outlined
                        :rules="[$rules.required]"></v-text-field>
          <v-text-field label="Email" v-model="company.email" outlined :rules="[$rules.required, $rules.email]">
          </v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.website')" v-model="company.web" outlined>
          </v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.regNumber')" v-model="company.ogrn" outlined
                        :rules="[$rules.required]">
          </v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.vat')" v-model="company.van" outlined
                        :rules="[$rules.required]">
          </v-text-field>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.address') }}</div>
          <v-text-field v-model="company.address.street" class="address__street"
                        :label="$vuetify.lang.t('$vuetify.street')" outlined :rules="[$rules.required]"></v-text-field>
          <div class="form__row form__address">
            <v-text-field v-model="company.address.house" class="address__house"
                          :label="$vuetify.lang.t('$vuetify.house')" outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="company.address.entrance" class="address__entrance"
                          :label="$vuetify.lang.t('$vuetify.entrance')" outlined></v-text-field>
            <v-text-field v-model="company.address.flat" class="address__flat"
                          :label="$vuetify.lang.t('$vuetify.flat')" outlined>
            </v-text-field>
          </div>
          <v-text-field v-model="company.address.index" class="address__index"
                        :label="$vuetify.lang.t('$vuetify.index')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="company.address.city" class="address__city"
                        :label="$vuetify.lang.t('$vuetify.city')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="company.address.country" class="address__country"
                        :label="$vuetify.lang.t('$vuetify.country')" outlined :rules="[$rules.required]"></v-text-field>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="editing = false; loadData()">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </button>
            <button class="btn btn-primary" @click="edit">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </div>
      </div>
      <div class="profile-tabs cards__single">
        <div class="profile-tabs__content">
          <div class="profile-tabs__content-item">
            <div class="characteristics" v-if="!editing">
              <div class="characteristics__list">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.bankAccount') }}</div>

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.bank') }}</div>
                  <div class="characteristics__val">
                    {{ company.bank }}
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.bankAccount') }}</div>
                  <div class="characteristics__val">
                    {{ company.bank_account }}
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.bic') }}
                  </div>
                  <div class="characteristics__val">
                    {{ company.bic }}
                  </div>
                </div>
              </div>
              <div class="characteristics__list">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.description') }}</div>
                <div v-html="company.description"></div>
              </div>

              <div class="characteristics__list" v-if="company.create_date">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.rentInfo') }}</div>
                <div class="characteristics__item" v-if="company.create_date">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.createdDateTenant') }}</div>
                  <div class="characteristics__val">
                    {{ new Date(company.create_date).toLocaleDateString('Ru-ru') }}
                  </div>
                </div>
                <!--                <div class="characteristics__item" v-if="company.paid_until">-->
                <!--                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.paid_until') }}</div>-->
                <!--                  <div class="characteristics__val">-->
                <!--                    {{ new Date(company.paid_until).toLocaleDateString('Ru-ru') }}-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div class="characteristics__item">-->
                <!--                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.onTrial') }}</div>-->
                <!--                  <div class="characteristics__val">-->
                <!--                    <span v-if="company.on_trial">{{ $vuetify.lang.t('$vuetify.yes') }}</span>-->
                <!--                    <span v-else>{{ $vuetify.lang.t('$vuetify.no') }}</span>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div class="characteristics__item" v-if="company.tariff_plan && company.tariff_plan.name">-->
                <!--                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.tariffPlan') }}</div>-->
                <!--                  <div class="characteristics__val">-->
                <!--                    {{-->
                <!--                      company.tariff_plan.name[$vuetify.lang.current] ? company.tariff_plan.name[$vuetify.lang.current] : company.tariff_plan.name['eng'] ? company.tariff_plan.name['eng'] : company.tariff_plan.name['fin']-->
                <!--                    }}-->
                <!--                  </div>-->
                <!--                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.workerLimit') }}</div>-->
                <!--                  <div class="characteristics__val">-->
                <!--                    {{ company.tariff_plan.worker_limit }}-->
                <!--                  </div>-->
                <!--                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.accounting.card.cost') }}</div>-->
                <!--                  <div class="characteristics__val">-->
                <!--                    {{ company.tariff_plan.price }} €-->
                <!--                  </div>-->
                <!--                </div>-->

                <!--                <button class="btn btn-secondary" @click="openChangeTariff">-->
                <!--                  {{ $vuetify.lang.t('$vuetify.changeTariff') }}-->
                <!--                </button>-->
                <!--                <button class="btn btn-secondary" @click="payTariff">-->
                <!--                  {{ $vuetify.lang.t('$vuetify.pay') }}-->
                <!--                </button>-->
              </div>
            </div>

            <div v-if="!editing" class="details accordions">
              <div class="details__accordion profile-object" v-for="detail in details" :key="detail.id"
                   @click="opened_detail = (opened_detail === detail.id ? 0 : detail.id)">
                <div class="profile-object__title details__title">
                  {{ detail.name }}
                  <div class="rows__dot-menu">
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="20"
                            height="5"
                            viewBox="0 0 20 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                          </svg>
                        </v-btn>
                      </template>
                      <div class="rows__dot-menu-content">
                        <div class="btn-wrap" @click="editDetailOpen(detail)">
                          {{ $vuetify.lang.t('$vuetify.edit') }}
                          <button class="btn-icon btn-action">
                            <edit-icon></edit-icon>
                          </button>
                        </div>
                        <div class="btn-wrap" @click="detail_delete=detail.id; confirm_detail_modal=true">
                          {{ $vuetify.lang.t('$vuetify.delete') }}
                          <button class="btn-icon btn-action">
                            <delete-icon></delete-icon>
                          </button>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div class="details__content accordion__content"
                     :class="{ 'accordion__content--close': opened_detail !== detail.id }">
                  <div class="detail__characteristic flex" v-for="(value, name) in detail.options"
                       :key="detail.id + name">
                    <span class="characteristics__title">{{ $vuetify.lang.t('$vuetify.' + name) }}</span>
                    <span class="characteristics__content">{{ value }}</span>
                  </div>
                  <div class="profile-object__company">
                    {{ detail.comment }}
                  </div>
                </div>
              </div>
              <button class="btn-secondary btn"
                      @click="addDetailModal = true; detail_action='add'">
                + {{ $vuetify.lang.t('$vuetify.addDetails') }}
              </button>
            </div>

            <div v-if="editing">
              <div class="sign-up__form sign-up__form--profile">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.bankAccount') }}</div>
                <v-text-field v-model="company.bank" :label="$vuetify.lang.t('$vuetify.bank')"
                              outlined :rules="[$rules.required]"></v-text-field>
                <v-text-field v-model="company.bank_account" :label="$vuetify.lang.t('$vuetify.bankAccount')"
                              outlined :rules="[$rules.required]"></v-text-field>
                <v-text-field v-model="company.bic" :label="$vuetify.lang.t('$vuetify.bic')"
                              outlined :rules="[$rules.required]"></v-text-field>
              </div>
              <div class="sign-up__form--profile">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.description') }}</div>
                <text-editor v-model="company.description"></text-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="changeTariffModal">
      <div class="modal modal-big">
        <div class="h1">
          <span>{{ $vuetify.lang.t('$vuetify.chooseTariff') }}</span>
        </div>
        <div class="cards mb-6">
          <div class="cards__single" v-for="plan in tariffPlans" :key="plan.id">
            <div class="cards__main-info">
              <h2 class="tariff-plan__title mb-3"> {{
                  plan.name[$vuetify.lang.current] ? plan.name[$vuetify.lang.current] : plan.name['eng'] ? plan.name['eng'] : plan.name['fin']
                }} </h2>
              <div class="tariff-plan__price">{{ plan.price }}€</div>
            </div>
            <div class="tariff-plan__description mb-3" v-html="plan.description"></div>
            <div class="mb-3">
              <span class="bolder">{{ $vuetify.lang.t("$vuetify.workerLimit") }}: </span>
              <span>{{ plan.worker_limit }}</span>
            </div>
            <div class="bolder mb-1">{{ $vuetify.lang.t("$vuetify.functions") }}:</div>
            <ul class="tariff-plan__functions mb-3">
              <template v-for="func in functions">
                <li v-if="plan.features.indexOf(func.id) !== -1" :key="func.id">
                  {{ $vuetify.lang.t("$vuetify.menu." + func.name.toLowerCase() + "") }}
                </li>
              </template>
            </ul>
            <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
            <button class="btn tariff-plan__btn"
                    :class="{'btn-secondary': (company.tariff_plan?company.tariff_plan.id:company.tariff_plan)===plan.id, 'btn-primary': (company.tariff_plan?company.tariff_plan.id:company.tariff_plan)!==plan.id}"
                    @click="company.tariff_plan=plan">
              <span v-if="(company.tariff_plan?company.tariff_plan.id:company.tariff_plan)!==plan.id">
                {{ $vuetify.lang.t('$vuetify.choose') }}</span>
              <span v-if="(company.tariff_plan?company.tariff_plan.id:company.tariff_plan)===plan.id">
                {{ $vuetify.lang.t('$vuetify.chosen') }}</span>
            </button>
          </div>
        </div>
        <div class="sign-up__buttons btn-group">
          <button class="btn btn-secondary" @click="changeTariffModal=false; loadData()">
            {{ $vuetify.lang.t('$vuetify.cancel') }}
          </button>
          <button class="btn btn-primary" @click="editCompany">
            {{ $vuetify.lang.t('$vuetify.save') }}
          </button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="addDetailModal">
      <div class="modal">
        <div class="h1">
          <span v-if="detail_action === 'add'">{{ $vuetify.lang.t('$vuetify.addDetails') }}</span><span
          v-if="detail_action === 'edit'">{{ $vuetify.lang.t('$vuetify.editDetails') }}</span>
        </div>
        <v-form ref="form" @submit.prevent="" onkeydown="return event.key !== 'Enter';">
          <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="newDetail.name"
                        outlined :rules="[$rules.required]"></v-text-field>
          <v-select v-model="newDetail.type" class="custom" :label="$vuetify.lang.t('$vuetify.selectType')"
                    :items="types" item-text="name" item-value="value" outlined attach
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }" :rules="[$rules.required]"></v-select>
          <div v-if="newDetail.type === 'bank'">
            <v-text-field v-model="newDetail.options.bank" :label="$vuetify.lang.t('$vuetify.accounting.card.bank')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.bic" label="S.W.I.F.T./BIC"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.iban" label="IBAN"
                          outlined :rules="[$rules.required]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'e-account'">
            <v-text-field v-model="newDetail.options.address"
                          :label="$vuetify.lang.t('$vuetify.accounting.card.address')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.operator"
                          :label="$vuetify.lang.t('$vuetify.operator')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.operator_id"
                          :label="$vuetify.lang.t('$vuetify.operator_id')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.invoice_address"
                          :label="$vuetify.lang.t('$vuetify.invoice_address')"
                          outlined :rules="[$rules.required]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'email'">
            <v-text-field v-model="newDetail.options.email" label="Email" outlined
                          :rules="[$rules.required, $rules.email]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'post'">
            <v-text-field v-model="newDetail.options.client_name"
                          :label="$vuetify.lang.t('$vuetify.client_name')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.address"
                          :label="$vuetify.lang.t('$vuetify.accounting.card.address')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <div class="form__row form__address">
              <v-text-field class="address__index"
                            v-model="newDetail.options.index"
                            :label="$vuetify.lang.t('$vuetify.index')"
                            outlined :rules="[$rules.required]"
              ></v-text-field>
              <v-text-field class="address__city"
                            v-model="newDetail.options.city"
                            :label="$vuetify.lang.t('$vuetify.city')"
                            outlined :rules="[$rules.required]"
              ></v-text-field>
            </div>
          </div>
          <v-textarea v-model="newDetail.comment" :label="$vuetify.lang.t('$vuetify.comment')" outlined></v-textarea>
          <v-checkbox v-model="newDetail.public"
                      :label="$vuetify.lang.t('$vuetify.public')"></v-checkbox>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="closeAddDetail">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="addDetail">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <ConfirmModal v-model="confirm_detail_modal" @confirm="deleteDetail">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>

    <CoolLightBox
      :items="lightboxItems"
      :index="index"
      @close="index = null; lightboxItems=[]">
    </CoolLightBox>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>
  </div>
</template>

<script>
import SpinnerLoader from "@/components/SpinnerLoader";
import DeleteIcon from "@/components/icons/DeleteIcon";
import EditIcon from "@/components/icons/EditIcon";
import ConfirmModal from "@/components/confirmModal.vue";
import TextEditor from "@/views/TextEditor.vue";

export default {
  name: "SettingsCompanyProfileView",
  components: {
    TextEditor,
    ConfirmModal,
    SpinnerLoader,
    EditIcon,
    DeleteIcon,
  },
  data: function () {
    return {
      editing: false,
      company: {},
      tariffPlans: [],
      functions: [],
      details: [],

      lightboxItems: [],
      index: null,

      opened_detail: 0,
      newDetail: {
        options: {},
        client: this.id,
      },
      types: [
        {name: this.$vuetify.lang.t('$vuetify.accounting.card.bank'), value: "bank"},
        {name: this.$vuetify.lang.t('$vuetify.e-account'), value: "e-account"},
        {name: this.$vuetify.lang.t('$vuetify.email'), value: "email"},
        {name: this.$vuetify.lang.t('$vuetify.accounting.card.address'), value: "post"},
      ],
      detail_action: "add",
      addDetailModal: false,
      confirm_detail_modal: false,
      detail_delete: 0,

      photo: null,
      changeTariffModal: false,
      loader: false,
      form_loader: false,
      alertMsg: '',
      alertError: false,
    };
  },
  created: function () {
    this.loadData();
    this.loadDetails();
  },
  methods: {
    loadData() {
      this.$axios({
        url: this.$hostname + "time-tracking/my-organization",
        type: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.company = response.data.data.data;
          if (this.company.logo_path)
            this.lightboxItems.push(this.$media_url + this.company.logo_path);
          if (!this.company.address) {
            this.company.address = {}
          }
          if (!this.company.social) {
            this.company.social = {}
          }

          this.alertError = false
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadTariffs() {
      this.$axios({
        url: this.$hostname + "time-tracking/get-tariff-plans",
        method: "GET",
        params: {
          arch: true,
        },
      }).then((response) => {
        this.tariffPlans = response.data.data.data
        this.functions = response.data.data.functions
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadDetails() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/details",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.details = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    editCompany() {
      this.changeTariffModal = false
      this.loader = true
      this.company.address = JSON.stringify(this.company.address)
      this.company.tariff_plan = this.company.tariff_plan ? this.company.tariff_plan.id : null
      this.$axios({
        url: this.$hostname + "time-tracking/my-organization",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.company,
      }).then((response) => {
        this.editing = false;
        this.loadData();
        if (response.data.data.msg) {
          alert(response.data.data.msg)
        }
      }).catch((response) => {
        this.changeTariffModal = true
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.company.address = JSON.parse(this.company.address)
        this.loader = false
      })
    },

    edit() {
      if (this.photo)
        this.uploadFile();
      else {
        this.editCompany();
      }
    },
    uploadFile() {
      this.$axios({
        url: this.$hostname + "time-tracking/images/upload/tenants",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: this.photo,
        },
      })
        .then((response) => {
          this.company.logo_path = response.data.data;
          if (this.editing) {
            this.editCompany();
          }
        })
        .catch((error) => {
          this.alertMsg = "Ошибка загрузки файла";
          switch (error.response.status) {
            case 400:
              this.alertMsg = error.message;
              break;
            case 403:
              this.alertMsg = "Доступ запрещен";
              break;
            case 404:
              this.alertMsg = "Страница не найдена";
              break;
          }
          alert(this.alertMsg);
        });
    },
    clickInput() {
      document.getElementById("photo").click();
    },

    addDetail() {
      if (this.newDetail.id) {
        this.putDetail()
        return
      }
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      this.newDetail.organization = this.company.id
      this.$axios({
        url: this.$hostname + "time-tracking/organization/details",
        method: "POST",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDetail,
      }).then(() => {
        this.closeAddDetail()
        this.loadDetails()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
        this.newDetail.options = JSON.parse(this.newDetail.options)
      })
    },
    putDetail() {
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      this.newDetail.client = this.company.id
      this.$axios({
        url: this.$hostname + "time-tracking/organization/details",
        method: "PUT",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDetail,
      }).then(() => {
        this.newDetail.options = JSON.parse(this.newDetail.options)
        this.closeAddDetail()
        this.loadDetails()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteDetail() {
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      this.$axios({
        url: this.$hostname + "time-tracking/organization/details",
        method: "DELETE",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {id: this.detail_delete},
      }).then(() => {
        this.loadDetails()
        this.confirm_detail_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
        this.newDetail.options = JSON.parse(this.newDetail.options)
      })
    },
    editDetailOpen(item) {
      this.newDetail = item
      this.addDetailModal = true
      this.detail_action = "edit"
    },
    closeAddDetail() {
      this.addDetailModal = false
      this.newDetail = {
        options: {},
        client: this.id,
      }
    },

    openChangeTariff() {
      this.loadTariffs()
      this.changeTariffModal = true
    },

    payTariff() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/stripe",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          price_id: this.company.tariff_plan.price_id,
        },
      })
        .then((response) => {
          window.open(response.data.data.data, '_blank').focus();
        })
        .catch((error) => {
          this.alertMsg = this.$catch(error)
          alert(this.alertMsg);
        }).then(() => {
        this.loader = false
      });

    },

  },
}
</script>

<style scoped>

</style>